module.exports = __webpack_public_path__ + "static/media/ic_scann_in.c5f0df25.svg";